

















import { Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() appid!: string;

  imgbase64 = "";

  mounted() {
    this.loadQrcode();
  }

  async loadQrcode() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("oplatformapps/getQrcode", {
      appid: this.appid
    });

    //   console.log(res);

    if (res && res.Data) {
      this.imgbase64 = res.Data;
    }

    this.spinLoading = false;
  }
}
